import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import styled from 'styled-components';

import CircleIcon from './icons/circle_icon';
import ShowIcon from 'components/common/icons/fill/show-fill';

export default class VisibleButton extends React.Component {
  constructor(props) {
    super(props);
    this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
  }
  render() {
    return (
      <CircleIcon viewBox="0 0 25 25" {...this.props}>
        <StyledShowIcon />
      </CircleIcon>
    );
  }
}

const StyledShowIcon = styled(ShowIcon)`
  path {
    transform: scale(0.6);
    transform-origin: center;
  }
`;
